<template>
  <div class="loading">
    <h1>Loading...</h1>
  </div>
</template>

<script>
export default {
  name: 'LoadingScreen',
  methods: {
    submit() {
      this.$router.push({ name: 'details' });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/colors.scss';
.loading {
  background-color: $secondary;
  color: $white;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  h1 {
    text-align: center;
    vertical-align: middle;
  }
}
</style>
